(() => {
  const root = document.querySelector('[data-bba-makeup-filters]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const catalog = root.closest('[data-bba-catalog]');
  const container = catalog.querySelector('#ProductGridContainer');
  const config = JSON.parse(root.querySelector('[data-bba-makeup-config]').textContent);
  const paramsByGroup = { category: 'bba_makeup_category' };
  const strings = JSON.parse(root.querySelector('[data-bba-makeup-strings]').textContent);
  const words = (key, count) => strings[key].replace('__COUNT__', String(count));
  const nativeNames = ['filter.p.product_type', 'filter.p.vendor', 'filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'];
  const brandName = 'filter.p.vendor';
  const brandAliases = new Set(['BBA', 'BBA By Suleman', 'BBA by Suleman']);
  const brandLabel = value => brandAliases.has(value) ? 'BBA' : value;
  for (const form of catalog.querySelectorAll('facet-filters-form form')) {
    let grouped;
    for (const input of form.querySelectorAll('input[name="filter.p.vendor"]')) {
      if (!brandAliases.has(input.value)) continue;
      if (grouped) { input.closest('li').remove(); continue; }
      grouped = input;
      input.value = 'BBA';
      const label = input.closest('label');
      label.querySelector('.facet-checkbox__text-label').textContent = 'BBA';
      label.querySelector('.visually-hidden').textContent = 'BBA';
    }
  }
  const status = root.querySelector('[role=status]');
  const retry = root.querySelector('[data-makeup-retry]');
  const sectionId = container.querySelector('#product-grid').dataset.id;
  const cache = new Map();
  const knownValues = new Map();
  const productFields = { 'filter.p.product_type': 'type', 'filter.p.vendor': 'vendor', 'filter.p.m.bba.budget_box': 'budgetBox', 'filter.p.m.bba.ultimate_budget_box': 'ultimateBudgetBox' };
  const normalize = value => value === true ? '1' : value === false ? '0' : value === null ? '' : String(value);
  const isNative = key => nativeNames.includes(key) || key.startsWith('filter.v.option.') || Object.hasOwn(productFields, key);
  const sliderUpdates = [];
  for (const slider of root.querySelectorAll('[data-makeup-slider]')) {
    const rail = slider.querySelector('.bba-makeup-filters__rail');
    const previous = slider.querySelector('[data-makeup-prev]'), next = slider.querySelector('[data-makeup-next]');
    const update = () => {
      const atStart = rail.scrollLeft <= 2, atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      previous.disabled = atStart; next.disabled = atEnd;
      slider.dataset.atStart = String(atStart); slider.dataset.atEnd = String(atEnd);
    };
    const move = direction => rail.scrollBy({ left: direction * Math.max(180, rail.clientWidth * .8), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const buttons = [...rail.querySelectorAll('button:not(:disabled):not([hidden])')], index = buttons.indexOf(document.activeElement);
      if (index < 0) { move(event.key === 'ArrowLeft' || event.key === 'Home' ? -1 : 1); return; }
      const target = event.key === 'Home' ? buttons[0] : event.key === 'End' ? buttons.at(-1) : buttons[Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)))];
      target?.focus({ preventScroll: true }); target?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
    });
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
    else window.addEventListener('resize', update);
    sliderUpdates.push(update); requestAnimationFrame(update);
  }
  document.fonts?.ready.then(() => sliderUpdates.forEach(update => update()));
  let state = new URLSearchParams(location.search), records = [], matches = [], shown = 12, revision = 0, timer;
  let desired = new URLSearchParams(state);
  const node = (tag, className, text) => { const element = document.createElement(tag); if (className) element.className = className; if (text !== undefined) element.textContent = text; return element; };
  const options = () => config.categories;
  const optionMatches = (record, option) => option.types.includes(record.type) || option.handles.includes(record.handle);
  const values = (params, name) => [...new Set(params.getAll(name).flatMap(value => name.startsWith('filter.v.price.') || knownValues.get(name)?.has(value) ? [value] : value.split(',')).map(value => name === brandName ? brandLabel(value) : value))];
  function matchesState(record, params, ignore) {
    const category = params.get(paramsByGroup.category);
    if (category && ignore !== paramsByGroup.category) {
      const option = options().find(item => item.key === category);
      if (!option || !optionMatches(record, option)) return false;
    }
    for (const [name, field] of Object.entries(productFields)) {
      const selected = values(params, name);
      if (name !== ignore && selected.length && !selected.includes(normalize(field === 'vendor' ? brandLabel(record[field]) : record[field]))) return false;
    }
    const selectedAvailability = ignore === 'filter.v.availability' ? [] : values(params, 'filter.v.availability');
    const minimum = ignore === 'price' ? NaN : Number.parseFloat((params.get('filter.v.price.gte') || '').replace(/,/g, '')) * 100;
    const maximum = ignore === 'price' ? NaN : Number.parseFloat((params.get('filter.v.price.lte') || '').replace(/,/g, '')) * 100;
    const optionFilters = [...new Set(params.keys())].filter(key => key.startsWith('filter.v.option.') && key !== ignore).map(key => [key.slice('filter.v.option.'.length), values(params, key)]);
    return record.variants.some(variant => (!selectedAvailability.length || selectedAvailability.includes(variant.available ? '1' : '0')) && (!Number.isFinite(minimum) || variant.price >= minimum) && (!Number.isFinite(maximum) || variant.price <= maximum) && optionFilters.every(([name, selected]) => selected.includes(variant.options[name])));
  }
  async function loadAll(params) {
    const url = new URL(root.dataset.collectionUrl.replace(/\/collections\/[^/]+$/, '/collections/all'), location.origin);
    for (const [key, value] of params) {
      if (key === 'page' || key === 'section_id' || key.startsWith('bba_makeup_') || isNative(key)) continue;
      url.searchParams.append(key, value);
    }
    url.searchParams.set('sort_by', params.get('sort_by') || root.dataset.defaultSort);
    url.searchParams.set('section_id', 'bba-makeup-source');
    const cacheKey = url.href;
    if (!cache.has(cacheKey)) cache.set(cacheKey, (async () => {
      const data = [], seen = new Set(), seenPages = new Set();
      let next = url, total, scanned = 0;
      while (next) {
        if (seenPages.has(next.href)) throw new Error('Repeated page');
        seenPages.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Source unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pageNode = doc.querySelector('[data-bba-makeup-page]');
        if (!pageNode) throw new Error('Missing collection data');
        const page = JSON.parse(pageNode.textContent);
        total = page.total; scanned += page.scanned;
        for (const template of doc.querySelectorAll('[data-bba-makeup-record]')) {
          const item = JSON.parse(template.content.querySelector('[data-bba-makeup-meta]').textContent);
          const card = template.content.querySelector('li.grid__item');
          if (!card || seen.has(item.id)) continue;
          seen.add(item.id); data.push({ ...item, card });
        }
        next = page.next ? new URL(page.next, location.origin) : null;
        if (next) { for (const [key, value] of url.searchParams) if (key !== 'page' && !next.searchParams.has(key)) next.searchParams.append(key, value); }
      }
      if (scanned !== total) throw new Error('Incomplete collection data');
      return data.filter(item => item.variants.some(variant => variant.available)).concat(data.filter(item => !item.variants.some(variant => variant.available)));
    })().catch(error => { cache.delete(cacheKey); throw error; }));
    return cache.get(cacheKey);
  }
  function updatePills() {
    for (const button of root.querySelectorAll('[data-makeup-group]')) {
      const group = button.dataset.makeupGroup, key = paramsByGroup[group], value = button.dataset.makeupKey;
      const option = options().find(item => item.key === value);
      const active = (state.get(key) || '') === value;
      const count = records.filter(record => matchesState(record, state, key) && (!option || optionMatches(record, option))).length;
      button.hidden = Boolean(option && count === 0 && !active);
      button.disabled = false;
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[data-makeup-count]').textContent = String(count);
      button.setAttribute('aria-label', `${button.querySelector('span').textContent}, ${words('products', count)}`);
    }
    requestAnimationFrame(() => sliderUpdates.forEach(update => update()));
  }
  function updateFacets() {
    const eligibleByParam = new Map();
    for (const input of catalog.querySelectorAll('facet-filters-form input[type=checkbox]')) {
      const selected = values(state, input.name);
      input.checked = selected.includes(input.value);
      if (!eligibleByParam.has(input.name)) eligibleByParam.set(input.name, records.filter(record => matchesState(record, state, input.name)));
      const eligible = eligibleByParam.get(input.name);
      if (!isNative(input.name)) continue;
      const candidate = new URLSearchParams(state); candidate.delete(input.name); candidate.append(input.name, input.value);
      const count = eligible.filter(record => matchesState(record, candidate)).length;
      input.disabled = count === 0 && !input.checked;
      const label = input.closest('label'); label.classList.toggle('disabled', input.disabled);
      const text = label.querySelector('.facet-checkbox__text'), title = label.querySelector('.facet-checkbox__text-label').textContent;
      for (const child of [...text.childNodes]) if (child.nodeType === Node.TEXT_NODE) child.remove();
      text.append(document.createTextNode(` (${count})`));
      label.querySelector('.visually-hidden').textContent = `${title} (${words('products', count)})`;
    }
    for (const detail of catalog.querySelectorAll('details.js-filter')) {
      const count = detail.querySelectorAll('input[type=checkbox]:checked').length;
      const badge = detail.querySelector('.facets__selected');
      if (badge) { badge.textContent = ` (${count})`; badge.classList.toggle('hidden', !count); }
      const title = detail.querySelector('.facets__summary-label');
      if (title) detail.querySelector('summary').setAttribute('aria-label', `${title.firstChild.textContent.trim()} (${words('selected', count)})`);
    }
    for (const input of catalog.querySelectorAll('price-range input')) if (document.activeElement !== input) input.value = state.get(input.name) || '';
    for (const select of catalog.querySelectorAll('select[name=sort_by]')) select.value = state.get('sort_by') || root.dataset.defaultSort;
    const countText = words('products', matches.length);
    for (const element of catalog.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count')) { element.textContent = countText; element.dataset.productCount = String(matches.length); element.classList.remove('loading'); }
    for (const spinner of catalog.querySelectorAll('facet-filters-form .loading__spinner')) spinner.classList.add('hidden');
    updateActiveChips();
  }
  function updateActiveChips() {
    for (const holder of catalog.querySelectorAll('.active-facets-desktop, .active-facets-mobile')) {
      holder.querySelectorAll(':scope > facet-remove:not(.active-facets__button-wrapper), [data-bba-makeup-active]').forEach(item => item.remove());
      const block = node('span'); block.dataset.bbaMakeupActive = '';
      for (const key of new Set(state.keys())) {
        if (!key.startsWith('filter.')) continue;
        for (const value of values(state, key)) {
          const input = [...catalog.querySelectorAll('facet-filters-form input[type=checkbox]')].find(item => item.name === key && item.value === value);
          const text = input?.closest('label').querySelector('.facet-checkbox__text-label').textContent || value;
          const prefix = key.endsWith('.gte') ? strings.minPrice : key.endsWith('.lte') ? strings.maxPrice : '';
          const button = node('button', 'active-facets__button bba-makeup-active'); button.type = 'button';
          button.dataset.makeupRemove = key; button.dataset.makeupValue = value;
          button.setAttribute('aria-label', strings.remove.replace('__LABEL__', prefix + text));
          button.append(node('span', 'active-facets__button-inner', `${prefix}${text} ×`)); block.append(button);
        }
      }
      holder.append(block);
    }
  }
  let autoObserver, autoFrame;
  function appendNext(focusMore = false) {
    if (root.getAttribute('aria-busy') === 'true' || shown >= matches.length) return;
    shown = Math.min(shown + 12, matches.length);
    state.set('page', String(Math.ceil(shown / 12))); desired = new URLSearchParams(state);
    history.replaceState({ searchParams: state.toString(), bbaMakeup: true }, '', `${root.dataset.collectionUrl}?${state}`);
    renderGrid(focusMore, true);
  }
  function armAutoLoad() {
    autoObserver?.disconnect();
    const sentinel = container.querySelector('[data-makeup-auto-load]');
    if (!sentinel || !window.IntersectionObserver) return;
    const generation = revision;
    autoObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting && entry.target === sentinel) || !sentinel.isConnected) return;
      autoObserver.disconnect();
      cancelAnimationFrame(autoFrame);
      autoFrame = requestAnimationFrame(() => {
        if (generation === revision && sentinel.isConnected) appendNext();
      });
    }, { rootMargin: '0px 0px 800px 0px', threshold: 0 });
    autoObserver.observe(sentinel);
  }
  function renderGrid(focusMore = false, append = false) {
    if (!window.IntersectionObserver) shown = matches.length;
    const selectedVariants = [...container.querySelectorAll('input[type=radio]:checked')].map(input => input.value);
    const collection = append ? container.querySelector('.collection') : node('div', 'collection');
    if (matches.length) {
      const grid = append ? collection.querySelector('#product-grid') : node('ul', 'grid product-grid grid--2-col-tablet-down grid--3-col-desktop bba-catalog__products');
      grid.id = 'product-grid'; grid.dataset.id = sectionId; grid.setAttribute('role', 'list');
      for (const record of matches.slice(append ? grid.children.length : 0, shown)) grid.append(document.importNode(record.card, true));
      if (!append) collection.append(grid);
      collection.querySelector('.bba-catalog__more')?.remove();
      const more = node('div', 'bba-catalog__more');
      if (shown < matches.length) more.dataset.makeupAutoLoad = '';
      const progress = node('p', '', strings.progress.replace('__SHOWN__', String(Math.min(shown, matches.length))).replace('__TOTAL__', String(matches.length))); progress.setAttribute('role', 'status'); progress.setAttribute('aria-live', 'polite'); progress.tabIndex = -1; more.append(progress); collection.append(more);
    } else {
      const empty = node('div', 'bba-catalog__empty'); empty.id = 'product-grid'; empty.dataset.id = sectionId;
      empty.append(node('h2', '', strings.emptyTitle), node('p', '', strings.emptyText));
      const clear = node('button', 'bba-catalog__button', strings.clear); clear.type = 'button'; clear.dataset.makeupClear = ''; empty.append(clear);
      collection.append(empty);
    }
    if (!append) {
      container.replaceChildren(collection);
      for (const value of selectedVariants) {
        const radio = [...container.querySelectorAll('input[type=radio]')].find(input => input.value === value);
        if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    if (focusMore) container.querySelector('[role=status]')?.focus({ preventScroll: true });
    if (root.getAttribute('aria-busy') !== 'true') armAutoLoad();
  }
  async function apply(params, historyMode = 'push') {
    params = new URLSearchParams(params);
    const previousBrands = params.getAll(brandName);
    const groupedBrands = values(params, brandName);
    if (JSON.stringify(previousBrands) !== JSON.stringify(groupedBrands)) {
      params.delete(brandName);
      for (const brand of groupedBrands) params.append(brandName, brand);
      const url = new URL(location.href); url.search = params.toString();
      history.replaceState({ searchParams: params.toString(), bbaMakeup: true }, '', url);
    }
    if (params.has('filter.v.option.color')) {
      params.delete('filter.v.option.color');
      params.delete('page');
      const url = new URL(location.href); url.search = params.toString();
      history.replaceState({ searchParams: params.toString(), bbaMakeup: true }, '', url);
    }
    const requestId = ++revision;
    autoObserver?.disconnect(); cancelAnimationFrame(autoFrame);
    desired = new URLSearchParams(params);
    root.setAttribute('aria-busy', 'true'); status.textContent = strings.updating; retry.hidden = true;
    container.setAttribute('aria-busy', 'true');
    try {
      const all = await loadAll(params);
      if (requestId !== revision) return;
      records = all.filter(record => !config.excludedHandles.includes(record.handle));
      knownValues.clear();
      const remember = (name, value) => { if (!knownValues.has(name)) knownValues.set(name, new Set()); knownValues.get(name).add(value); };
      for (const record of records) {
        for (const [name, field] of Object.entries(productFields)) remember(name, normalize(record[field]));
        for (const variant of record.variants) for (const [name, value] of Object.entries(variant.options)) remember('filter.v.option.' + name, value);
      }
      const heroCount = document.querySelector('.bba-catalog__hero-count');
      if (heroCount && ![...params.keys()].some(key => key.startsWith('filter.') && !isNative(key))) heroCount.textContent = words('products', records.length);
      state = new URLSearchParams(params); shown = Math.max(12, (Number(state.get('page')) || 1) * 12);
      matches = records.filter(record => matchesState(record, state));
      if (historyMode !== 'none') history[historyMode === 'replace' ? 'replaceState' : 'pushState']({ searchParams: state.toString(), bbaMakeup: true }, '', `${root.dataset.collectionUrl}${state.size ? '?' + state : ''}`);
      renderGrid(); updatePills(); updateFacets(); catalog.dataset.bbaMakeupReady = 'true';
      status.textContent = ''; root.setAttribute('aria-busy', 'false');
      container.setAttribute('aria-busy', 'false'); armAutoLoad();
    } catch (error) {
      if (requestId !== revision) return;
      status.textContent = strings.error; retry.hidden = false; root.setAttribute('aria-busy', 'false');
      container.setAttribute('aria-busy', 'false');
    }
  }
  function clearAll(params) { for (const key of [...params.keys()]) if (key.startsWith('filter.') || key.startsWith('bba_makeup_') || key === 'page') params.delete(key); }
  catalog.addEventListener('input', event => {
    const input = event.target;
    if (!input.closest('facet-filters-form') || !input.name) return;
    revision += 1; autoObserver?.disconnect(); cancelAnimationFrame(autoFrame);
    event.stopImmediatePropagation(); clearTimeout(timer);
    const next = new URLSearchParams(desired); next.delete('page'); next.delete(input.name);
    if (input.type === 'checkbox') {
      for (const checked of input.closest('form').querySelectorAll('input[type=checkbox]:checked')) if (checked.name === input.name) next.append(input.name, checked.value);
    } else if (input.value !== '') next.set(input.name, input.name.startsWith('filter.v.price.') ? input.value.replace(/,/g, '') : input.value);
    desired = next; timer = setTimeout(() => apply(next), 180);
  }, true);
  catalog.addEventListener('click', event => {
    const pill = event.target.closest('[data-makeup-group]');
    const remove = event.target.closest('[data-makeup-remove]');
    const more = event.target.closest('[data-makeup-more], [data-bba-load-more]');
    const clear = event.target.closest('[data-makeup-clear], facet-remove a');
    if (!pill && !remove && !more && !clear && !event.target.closest('[data-makeup-retry]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); clearTimeout(timer);
    if (more) {
      if (root.getAttribute('aria-busy') === 'true' && catalog.dataset.bbaMakeupReady) return;
      if (!catalog.dataset.bbaMakeupReady) { const next = new URLSearchParams(desired); next.set('page', '2'); apply(next, 'replace'); return; }
      appendNext(true); return;
    }
    const next = new URLSearchParams(desired); next.delete('page');
    if (pill) {
      const key = paramsByGroup[pill.dataset.makeupGroup], value = pill.dataset.makeupKey;
      if (!value || next.get(key) === value) next.delete(key); else next.set(key, value);
    } else if (remove) {
      const remaining = values(next, remove.dataset.makeupRemove).filter(value => value !== remove.dataset.makeupValue);
      next.delete(remove.dataset.makeupRemove); for (const value of remaining) next.append(remove.dataset.makeupRemove, value);
    } else if (clear) clearAll(next);
    apply(next);
  }, true);
  window.addEventListener('popstate', event => { event.stopImmediatePropagation(); clearTimeout(timer); apply(new URLSearchParams(location.search), 'none'); }, true);
  const initialData = catalog.querySelector('[data-bba-makeup-initial]');
  if (initialData) {
    try {
      records = JSON.parse(initialData.textContent);
      for (const record of records) {
        for (const [name, field] of Object.entries(productFields)) {
          if (!knownValues.has(name)) knownValues.set(name, new Set());
          knownValues.get(name).add(normalize(record[field]));
        }
      }
      updatePills();
    } catch {}
  }
  apply(state, 'none');
})();

